// Özel lig sayfasının (Junior Cup) alt bilgisi: logo, menü, yönetimden
// girilen alt bilgi metni ve sponsor şeridi.
import React from "react";
import { Link } from "react-router-dom";
import { SiteSponsorStrip } from "../components/SiteSponsors";
import { buildPortalMenu } from "./PortalHeader";
import { menuStyleVars, portalAssetUrl } from "./portalAssets";
import "./PortalChrome.css";

export default function PortalFooter({ portal }) {
  const menu = buildPortalMenu(portal);
  const logo = portalAssetUrl(portal.logoUrl);
  const name = portal.shortName || portal.name;

  return (
    <footer className="pm-footer" style={menuStyleVars(portal)}>
      <div className="pm-wrap pm-footer__inner">
        <div className="pm-footer__brand">
          {logo ? <img src={logo} alt="" /> : <span className="pm-brand__mark">{name.charAt(0)}</span>}
          <div>
            <strong>{portal.name}</strong>
            {portal.layout?.footerText ? <p>{portal.layout.footerText}</p> : null}
          </div>
        </div>
        <nav className="pm-footer__nav" aria-label="Alt menü">
          {menu.map((item) =>
            item.external ? (
              <a key={item.key} href={item.to} target="_blank" rel="noreferrer">
                {item.label}
              </a>
            ) : (
              <Link key={item.key} to={item.to}>
                {item.label}
              </Link>
            )
          )}
        </nav>
      </div>
      <div className="pm-wrap pm-footer__sponsors">
        <SiteSponsorStrip />
      </div>
      <div className="pm-wrap pm-footer__credit">
        <span>© {new Date().getFullYear()} {portal.name}</span>
        <Link to="/">ElitLig organizasyonudur</Link>
      </div>
    </footer>
  );
}
